import { ShieldCheck, BadgeCheck, Star, MapPin, PhoneCall, Users } from "lucide-react";
import { Reveal } from "./motion";
import { IMAGES } from "./data";

const FEATURES = [
  { icon: BadgeCheck, title: "Verified profiles", body: "Every driver and rider verifies their ID, phone and email." },
  { icon: Star, title: "Two-way ratings", body: "Reviews after every ride keep the community accountable and trusted." },
  { icon: MapPin, title: "Live trip sharing", body: "Share your route and ETA with loved ones straight from the app." },
  { icon: PhoneCall, title: "24/7 support", body: "A real team on standby for anything you need, any time of day." },
];

const STATS = [
  { k: "250k+", v: "Trips shared", icon: Users },
  { k: "180+", v: "Cities connected", icon: MapPin },
  { k: "4.9", v: "Avg. driver rating", icon: Star },
  { k: "1.2M", v: "kg CO₂ saved", icon: ShieldCheck },
];

export const TrustSafety = () => {
  return (
    <section id="safety" className="relative bg-[#f4f6fb] py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="mb-6 inline-flex items-center gap-3 font-display text-xs font-semibold uppercase tracking-[0.22em] text-[#2340b5]">
                <ShieldCheck className="h-4 w-4" strokeWidth={2} /> Trust & Safety
              </p>
              <h2 className="font-display text-4xl font-extrabold leading-none tracking-tighter text-[#12142b] sm:text-5xl">
                Safety isn't a feature. It's the name.
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-[#565b73]">
                We built SafeRide so you can travel between cities with total peace of mind — from the first booking to the final drop-off.
              </p>
            </Reveal>

            <Reveal delay={0.15} className="mt-10 overflow-hidden rounded-3xl shadow-lg shadow-[#12142b]/5">
              <img src={IMAGES.friends} alt="Friends enjoying a carpool ride" className="aspect-[4/3] w-full object-cover" />
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
            {FEATURES.map((f, i) => (
              <Reveal
                key={f.title}
                delay={i * 0.08}
                className="group rounded-2xl border border-[#12142b]/8 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#2340b5]/10 lg:p-10"
              >
                <span className="mb-8 grid h-12 w-12 place-items-center rounded-xl bg-[#2340b5]/8">
                  <f.icon className="h-6 w-6 text-[#2340b5] transition-transform duration-300 group-hover:-translate-y-0.5" strokeWidth={1.75} />
                </span>
                <h3 className="mb-3 font-display text-xl font-bold tracking-tight text-[#12142b]">{f.title}</h3>
                <p className="text-sm leading-relaxed text-[#565b73]">{f.body}</p>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 gap-5 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal
              key={s.v}
              delay={i * 0.08}
              className="rounded-2xl border border-[#12142b]/8 bg-white px-6 py-10 text-center shadow-sm"
            >
              <div className="font-display text-4xl font-black tracking-tight text-[#2340b5] lg:text-5xl">{s.k}</div>
              <div className="mt-2 font-display text-xs font-semibold uppercase tracking-[0.18em] text-[#565b73]">{s.v}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
